/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
import { EnUserType } from './en-user-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UserDto
 */
export interface UserDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof UserDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof UserDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof UserDto
     */
    firstName: string;

    /**
     * @type {string}
     * @memberof UserDto
     */
    lastName: string;

    /**
     * @type {string}
     * @memberof UserDto
     */
    fiscalCode: string;

    /**
     * @type {string}
     * @memberof UserDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof UserDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof UserDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof UserDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof UserDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {boolean}
     * @memberof UserDto
     */
    verified: boolean;

    /**
     * @type {JoinEntityDto}
     * @memberof UserDto
     */
    client: JoinEntityDto;

    /**
     * @type {EnUserType}
     * @memberof UserDto
     */
    type?: EnUserType;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof UserDto
     */
    authorities?: Array<JoinEntityDto>;

    /**
     * @type {string}
     * @memberof UserDto
     */
    note?: string | null;

    /**
     * Timestamp of member self-service account deletion — null when deleted by an admin or not deleted
     *
     * @type {string}
     * @memberof UserDto
     */
    selfDeletedAt: string | null;
}
